import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '增量描述',
    type: 'ISRFREQ_INCDESC',
}
